import React, {useState, useEffect} from "react";
import L from "leaflet";
import {Select} from "antd";
import {useTranslation} from "react-i18next";
import {
    getTileLayerPreference,
    saveTileLayerPreference,
    addTileLayerWithFallback,
    TILE_LAYER_TYPES
} from "../../../utils/helpers";

/**
 * Leaflet haritaları için tile layer seçim kontrolü
 * @param {Object} props
 * @param {Object} props.mapInstance - Leaflet map instance
 * @param {Object} props.tileLayerRef - Tile layer ref objesi
 * @param {Object} props.style - Ek stil özellikleri
 * @param {number} props.width - Select genişliği (default: 200)
 * @returns {JSX.Element}
 */
export const TileLayerControl = ({mapInstance, tileLayerRef, style = {}, width = 150}) => {
    const {t} = useTranslation("common");
    const [tileLayerType, setTileLayerType] = useState(() => getTileLayerPreference());

    // Harita seçenekleri - OSM dahil değil (sadece fallback için kullanılır)
    const tileLayerOptions = [
        {
            value: TILE_LAYER_TYPES.BASIC,
            label: t("map.tileLayer.basic")
        },
        {
            value: TILE_LAYER_TYPES.BRIGHT,
            label: t("map.tileLayer.bright")
        }
    ];

    // Tile layer tipini değiştir
    const handleTileLayerChange = newType => {
        setTileLayerType(newType);
        saveTileLayerPreference(newType);

        if (mapInstance && tileLayerRef.current) {
            // Eski tile layer'ı kaldır
            mapInstance.removeLayer(tileLayerRef.current);
            // Yeni tile layer ekle
            tileLayerRef.current = addTileLayerWithFallback(L, mapInstance, newType);
        }
    };

    // LocalStorage değişikliklerini dinle (farklı haritalar arası senkronizasyon için)
    useEffect(() => {
        const handleStorageChange = e => {
            if (e.key === "leaflet_tile_layer" && e.newValue) {
                const newType = e.newValue;
                setTileLayerType(newType);

                if (mapInstance && tileLayerRef.current) {
                    mapInstance.removeLayer(tileLayerRef.current);
                    tileLayerRef.current = addTileLayerWithFallback(L, mapInstance, newType);
                }
            }
        };

        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, [mapInstance, tileLayerRef]);

    return (
        <Select
            value={tileLayerType}
            onChange={handleTileLayerChange}
            options={tileLayerOptions}
            style={{width, ...style}}
            placeholder={t("map.tileLayer.label")}
        />
    );
};
